<template>
  <div class="record-wrap">
      <CommonHead title="档案详情"></CommonHead>
    <div class="content">
      <div class="record-title"><b>个人信息</b></div>
      <div class="my-card">
        <van-cell title="姓名" :value="recordDetail.name" />
        <van-cell title="性别" :value="recordDetail.gender" />
        <van-cell title="出生日期" :value="recordDetail.birthDate" />
        <van-cell title="家庭住址" :value="recordDetail.liveAddressDetail" />
      </div>
      <div class="record-title"><b>监护人信息</b></div>
      <div class="my-card">
        <van-cell title="母亲姓名" :value="recordDetail.matherName" />
        <van-cell title="母亲联系电话" :value="recordDetail.matherPhone" />
        <van-cell title="母亲证件号码" :value="recordDetail.matherIdCard" />
        <van-cell title="父亲姓名" :value="recordDetail.fatherName" />
        <van-cell title="父亲联系电话" :value="recordDetail.fatherPhone" />
        <van-cell title="父亲证件号码" :value="recordDetail.fatherIdCard" />
      </div>
      <div class="record-title"><b>接种信息</b></div>
      <div class="my-card">
        <van-cell title="档案编码" :value="recordDetail.profileCode" />
        <van-cell title="接种门诊" :value="recordDetail.povName" />
      </div>

    </div>

  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import { getRecordDetail } from "api/user";
export default {
  name: 'RecordDetails',
  components: {
    CommonHead
  },
  data() {
    return {
      id:this.$route.query.id,
      recordDetail:{},
    }
  },
  created(){
    this.userRecord()
  },
  methods: {
      userRecord(){
        getRecordDetail({id:this.id}).then(resp=>{
          this.recordDetail=resp.data
        }
          
        )
      }
  }
}
</script>
<style lang="less" scoped>
.record-wrap {
  width: 100%;
  box-sizing: border-box;

  .content {
    .record-title {
      padding: 11px 16px 0;
      font-size: 15px;
      color: #333333;
    }
   

  }

}

</style>